export default {"src":"/_next/static/media/chevron-left-grey.8ab75d57.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};